import { setProblemAsCompleted, setLessonAsCompleted } from "../../../../services/userService";


export function CheckCode(studentCode, output, checkboxes, user, lessonID) {

    const expectedCode1 = /public class Main\s*\{\s*\n\s{4}public static void main\(String\[\] args\)\s*\{\s*\n\s{8}System\.out\.println\("Java is fun!"\);\s*\n\s{8}if \(true\) \{\s*\n\s{12}System\.out\.println\("This line should be indented."\);\s*\n\s{8}\}\s*\n\s{4}\}\s*\n\}/;


    if (checkboxes.checkbox1 === false) {
        const testResult = expectedCode1.test(studentCode)
        if (testResult) {
            setProblemAsCompleted(lessonID + "P1", user.uid);
            checkboxes.checkbox1 = testResult;
            // console.log("Problem 1 passed");
        } else {
            console.log("Test Failed for problem1: 'age' variable of type int is not declared correctly.");
        }


    }


    if (checkboxes.checkbox1 === true) {
        // setLessonAsCompleted(lessonID, user.uid);
    }

    return checkboxes;
}